import React from 'react';
import styled from 'styled-components';

import Avatar from '../Avatar';
import ManagerStatus from '../ManagerStatus';
import Name from '../Name';
import { MANAGER_STATUSES as STATUSES } from '../../../../constants';

interface IManager {
  className?: string;
  avatarUrl?: string;
  name: string;
  phone?: string | null;
  status: (typeof STATUSES)[keyof typeof STATUSES] | null;
}

const Manager = React.memo(
  ({
    avatarUrl = '',
    name,
    phone = null,
    status = null,
    className = '',
  }: IManager) => (
    <StyledManager className={className}>
      <StyledAvatar name={name} url={avatarUrl} />
      <StyledName name={name} />
      {phone && <StyledPhone>{phone}</StyledPhone>}
      {status && <StyledStatus status={status} />}
    </StyledManager>
  )
);

Manager.displayName = 'Manager';

const StyledManager = styled.div`
  align-items: center;
  color: #4d4d4d;
  display: flex;
  font-size: 14px;
`;

const StyledAvatar = styled(Avatar)`
  height: 26px;
  width: 26px;
`;

const StyledName = styled(Name)`
  font-weight: normal;

  ${StyledAvatar} + & {
    margin-left: 10px;
  }
`;

const StyledPhone = styled.div`
  :before {
    content: '\u22C5';
    margin: 0 4px;
  }
`;

const StyledStatus = styled(ManagerStatus)`
  margin-left: 10px;
`;

export default Manager;
